// GENERATED from registry/audio.yaml by scripts/gen_audio_js.py. Do not edit.
//
// `python3 scripts/gen_audio_js.py --check` fails CI if this file and the YAML disagree, so an
// edit here is an edit that will be reverted. Change the YAML.

/** Every sound the app can play, fetched only after the visitor turns sound on (spec 0035). */
export const AUDIO = [
  {
    "id": "bed-ladder",
    "kind": "bed",
    "stage": "ladder",
    "file": "audio/bed-ladder.opus",
    "twin": "audio/bed-ladder.m4a",
    "seconds": 72,
    "kb": 585.6,
    "loop": true,
    "credit": "Fake Vega by John Bartmann, CC0"
  },
  {
    "id": "bed-earth",
    "kind": "bed",
    "stage": "earth",
    "file": "audio/bed-earth.opus",
    "twin": "audio/bed-earth.m4a",
    "seconds": 72,
    "kb": 585.6,
    "loop": true,
    "credit": "Above the Clouds by John Bartmann, CC0"
  },
  {
    "id": "bed-world",
    "kind": "bed",
    "stage": "world",
    "file": "audio/bed-world.opus",
    "twin": "audio/bed-world.m4a",
    "seconds": 72,
    "kb": 585.5,
    "loop": true,
    "credit": "Calabi-Yau by John Bartmann, CC0"
  },
  {
    "id": "bed-sun",
    "kind": "bed",
    "stage": "sun",
    "file": "audio/bed-sun.opus",
    "twin": "audio/bed-sun.m4a",
    "seconds": 72,
    "kb": 585.6,
    "loop": true,
    "credit": "Edge of the Sky by John Bartmann, CC0"
  },
  {
    "id": "sting-arrive",
    "kind": "sting",
    "file": "audio/sting-arrive.opus",
    "twin": "audio/sting-arrive.m4a",
    "seconds": 3,
    "kb": 24.8,
    "loop": false,
    "credit": "Crystal Twinkle by LaurenPonder (Freesound), CC0"
  },
  {
    "id": "sting-stage",
    "kind": "sting",
    "file": "audio/sting-stage.opus",
    "twin": "audio/sting-stage.m4a",
    "seconds": 3,
    "kb": 23.9,
    "loop": false,
    "credit": "Deep Whoosh #6 by Kinoton (Freesound), CC0"
  },
  {
    "id": "sting-end",
    "kind": "sting",
    "file": "audio/sting-end.opus",
    "twin": "audio/sting-end.m4a",
    "seconds": 2.5,
    "kb": 20.7,
    "loop": false,
    "credit": "harp flourish by nathanmanaker (Freesound), CC0"
  }
];
